import { createSystem, defaultConfig, defineConfig } from '@chakra-ui/react';

const customConfig = defineConfig({
  globalCss: {
    body: {
      colorPalette: 'moka',
    },
    '.react-grid-item.react-grid-placeholder': {
      background: '#d4d4d4 !important',
      borderRadius: '2xl',
    },
    '.rdp-root': {
      '--rdp-accent-color': 'yellow',
      '--rdp-accent-background-color': '{colors.yellow.100}',
    },
  },
  theme: {
    tokens: {
      fonts: {
        body: { value: 'var(--font-inter)' },
      },

      colors: {
        widgetBg: { value: '#F3EFEC' },
        widgetBgBlank: { value: '#F3EFEC5F' },
        moka: {
          50: { value: '#fafafa' },
          100: { value: '#f5f5f5' },
          200: { value: '#e5e5e5' },
          300: { value: '#d4d4d4' },
          400: { value: '#a1a1a1' },
          500: { value: '#737373' },
          600: { value: '#525252' },
          700: { value: '#404040' },
          800: { value: '#262626' },
          900: { value: '#171717' },
          950: { value: '#0a0a0a' },

          green: {
            foreground: { value: '{colors.green.800}' },
            background: { value: '{colors.green.100}' },
            over: { value: '{colors.green.50}' },
            shadow: { value: '{colors.green.300}' },
            status: { value: '{colors.green.400}' },
            solid: { value: '{colors.green.700}' },
            contrast: { value: '{colors.green.100}' },
          },
          orange: {
            foreground: { value: '{colors.orange.800}' },
            background: { value: '{colors.orange.100}' },
            over: { value: '{colors.orange.50}' },
            shadow: { value: '{colors.orange.300}' },
            status: { value: '{colors.orange.400}' },
            solid: { value: '{colors.orange.700}' },
            contrast: { value: '{colors.orange.100}' },
          },
          red: {
            foreground: { value: '{colors.red.800}' },
            background: { value: '{colors.red.100}' },
            over: { value: '{colors.red.50}' },
            shadow: { value: '{colors.red.300}' },
            status: { value: '{colors.red.500}' },
            solid: { value: '{colors.red.700}' },
            contrast: { value: '{colors.red.100}' },
          },
          purple: {
            foreground: { value: '{colors.purple.800}' },
            background: { value: '{colors.purple.100}' },
            over: { value: '{colors.purple.50}' },
            shadow: { value: '{colors.purple.300}' },
            status: { value: '{colors.purple.500}' },
            solid: { value: '{colors.purple.700}' },
            contrast: { value: '{colors.purple.100}' },
          },
          yellow: {
            foreground: { value: '{colors.yellow.800}' },
            background: { value: '{colors.yellow.100}' },
            over: { value: '{colors.yellow.50}' },
            shadow: { value: '{colors.yellow.300}' },
            status: { value: '{colors.yellow.500}' },
            solid: { value: '{colors.yellow.700}' },
            contrast: { value: '{colors.yellow.100}' },
          },
          teal: {
            foreground: { value: '{colors.teal.800}' },
            background: { value: '{colors.teal.100}' },
            over: { value: '{colors.teal.50}' },
            shadow: { value: '{colors.teal.300}' },
            status: { value: '{colors.teal.500}' },
            solid: { value: '{colors.teal.700}' },
            contrast: { value: '{colors.teal.100}' },
          },
          cyan: {
            foreground: { value: '{colors.cyan.800}' },
            background: { value: '{colors.cyan.100}' },
            over: { value: '{colors.cyan.50}' },
            shadow: { value: '{colors.cyan.300}' },
            status: { value: '{colors.cyan.500}' },
            solid: { value: '{colors.cyan.700}' },
            contrast: { value: '{colors.cyan.100}' },
          },
          pink: {
            foreground: { value: '{colors.pink.800}' },
            background: { value: '{colors.pink.100}' },
            over: { value: '{colors.pink.50}' },
            shadow: { value: '{colors.pink.300}' },
            status: { value: '{colors.pink.500}' },
            solid: { value: '{colors.pink.700}' },
            contrast: { value: '{colors.pink.100}' },
          },
          blue: {
            foreground: { value: '{colors.blue.800}' },
            background: { value: '{colors.blue.100}' },
            over: { value: '{colors.blue.50}' },
            shadow: { value: '{colors.blue.300}' },
            status: { value: '{colors.blue.500}' },
            solid: { value: '{colors.blue.700}' },
            contrast: { value: '{colors.blue.100}' },
          },
          none: {
            foreground: { value: '{colors.gray.800}' },
            background: { value: '{colors.gray.100}' },
            over: { value: '{colors.gray.50}' },
            shadow: { value: '{colors.gray.300}' },
            status: { value: '{colors.gray.500}' },
            solid: { value: '{colors.gray.700}' },
            contrast: { value: '{colors.gray.100}' },
          },
        },
      },
    },
    recipes: {
      button: {
        variants: {
          widgetToolbar: {
            bg: 'whiteAlpha.200',
          },
        },
      },
    },
    semanticTokens: {
      colors: {
        moka: {
          solid: { value: '{colors.moka.500}' },
          contrast: { value: '{colors.moka.100}' },
          fg: { value: '{colors.moka.700}' },
          muted: { value: '{colors.moka.100}' },
          subtle: { value: '{colors.moka.100}' },
          emphasized: { value: '{colors.moka.300}' },
          focusRing: { value: '{colors.moka.500}' },
        },
      },
    },
  },
});

export const system = createSystem(defaultConfig, customConfig);
